import round from 'helpers/mathRound';
import { getAlleDiscount } from '../helpers';
import { getDiscount } from './getDiscount';


const calculatePlanItemTotals = (products, items, selectedPlanQuoteDiscount) => {
  const initialAcc = {
    subtotal: 0,
    grandTotal: 0,
    totalAdditionalSubscriptionPrice: 0,
    discountTotal: 0,
    totalSubscription: 0,
    quoteDiscount: 0,
  };

  const calculateItemTotals = (acc, item) => {
    const {
      sku,
      qty,
      product_option: {
        extension_attributes: { subscription_id, quotepro_discounts: customQuoteproDiscounts },
      },
      price: updatedPrice,
    } = item;

    const {
      savings = 0,
      price = 0,
      subscription_active,
      subscription_options,
      additional_subscription_price = 0,
      quotepro_discounts,
      name = ''
    } = products.find((product) => product.sku === sku) || [];

    const productAlleData = { sku, name };
    const itemPrice = updatedPrice || price;
    const dataForDiscount = {
      savings: Number(savings),
      discount_options: quotepro_discounts && quotepro_discounts !== '[]' ? JSON.parse(quotepro_discounts) : [customQuoteproDiscounts],
      itemPrice,
    };

    const isAlleSKU = sku.includes('bdsku');
    const itemDiscount = isAlleSKU ? round(getAlleDiscount(productAlleData)) || 0 : round(getDiscount(item, dataForDiscount)) || 0;

    let itemRegularPrice = itemPrice ? itemPrice * qty : (itemPrice - Number(savings)) * qty;
    let itemSubscriptionPrice = 0;

    if (subscription_id) {
      const subscriptionData = subscription_options?.find((s) => Number(s.id) === Number(subscription_id));
      itemSubscriptionPrice = qty * round(subscriptionData?.installment_price + subscriptionData?.adjustment_price);
      const isSubscriptionActive = subscription_active === '1';
      const isNullPrice = subscriptionData?.installment_price === null && subscriptionData?.adjustment_price === null;

      if (isSubscriptionActive && !isNullPrice && itemPrice == 0) {
        itemRegularPrice = qty * round(subscriptionData?.installment_price + subscriptionData?.adjustment_price + Number(savings));
      }
    }

    let quoteDiscount = 0;

    if (selectedPlanQuoteDiscount?.price_type && selectedPlanQuoteDiscount?.price) {
      const { price_type, price } = selectedPlanQuoteDiscount;
      quoteDiscount = price_type === 'fixed' ?
        Math.abs(price / items?.length) :
        Math.abs(price * itemRegularPrice / 100);
    }

    const itemGrandTotal = itemRegularPrice - itemDiscount - quoteDiscount;

    const itemTotals = {
      subtotal: Number(itemRegularPrice),
      grandTotal: Number(itemGrandTotal),
      totalAdditionalSubscriptionPrice: Number(additional_subscription_price),
      discountTotal: Number(itemDiscount),
      totalSubscription: Number(itemSubscriptionPrice),
      quoteDiscount: Number(quoteDiscount),
    };

    return {
      subtotal: acc.subtotal + itemTotals.subtotal,
      grandTotal: acc.grandTotal + itemTotals.grandTotal,
      totalAdditionalSubscriptionPrice: acc.totalAdditionalSubscriptionPrice + itemTotals.totalAdditionalSubscriptionPrice,
      discountTotal: acc.discountTotal + itemTotals.discountTotal,
      totalSubscription: acc.totalSubscription + itemTotals.totalSubscription,
      quoteDiscount: acc.quoteDiscount + itemTotals.quoteDiscount,
    };
  };

  return items.reduce(calculateItemTotals, initialAcc);
};

export const calculatePlanTotals = (products, selectedPlan = []) => {
  if (!products) {
    return {
      subtotal: 0,
      grandTotal: 0,
      discountTotal: 0,
      quoteDiscount: 0,
      totalAdditionalSubscriptionPrice: 0,
      totalSubscription: 0,
    };
  }

  const calculatePlanTotalsReducer = (acc, plan) => {
    const { selectedItems, quoteDiscount } = plan;
    const calculatedPlan = calculatePlanItemTotals(products, selectedItems, quoteDiscount);

    return {
      subtotal: acc.subtotal + calculatedPlan.subtotal,
      grandTotal: acc.grandTotal + calculatedPlan.grandTotal,
      totalAdditionalSubscriptionPrice: acc.totalAdditionalSubscriptionPrice + calculatedPlan.totalAdditionalSubscriptionPrice,
      discountTotal: acc.discountTotal + calculatedPlan.discountTotal,
      totalSubscription: acc.totalSubscription + calculatedPlan.totalSubscription,
      quoteDiscount: acc.quoteDiscount + calculatedPlan.quoteDiscount,
    };
  };

  const initialTotals = {
    subtotal: 0,
    grandTotal: 0,
    discountTotal: 0,
    quoteDiscount: 0,
    totalAdditionalSubscriptionPrice: 0,
    totalSubscription: 0,
  };

  return selectedPlan.reduce(calculatePlanTotalsReducer, initialTotals);
};
